var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 0C45 0 44.766 35.2138 49.133 37.3569C53.5 39.5 76.8198 14.0589 76.8198 14.0589C76.8198 14.0589 52.9558 39.183 54.9779 43.5915C57 48 90 48 90 48C90 48 58 47 54.9779 52.4085C51.9558 57.817 76.8198 81.9411 76.8198 81.9411C76.8198 81.9411 54 57.5 49.133 58.6431C44.266 59.7862 45 96 45 96C45 96 46.5 61 40.867 58.6431C35.234 56.2862 13.1802 81.9411 13.1802 81.9411C13.1802 81.9411 36.5442 57.817 35.0221 52.4085C33.5 47 0 48 0 48C0 48 32.9554 48 35.0221 43.5915C37.0888 39.183 13.1802 14.0589 13.1802 14.0589C13.1802 14.0589 36.234 39.7138 40.867 37.3569C45.5 35 45 0 45 0Z",
    fill: "#2CE2BE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape3.8bf1e0ca732f86936319613c45bab578.svg";
export { ForwardRef as ReactComponent };